import { GraduationCap, Rocket, Headset } from 'lucide-react'

// Service engagements. Each entry becomes a card on /services and a page at
// /services/:id — adding a new engagement type is adding one object here.
// No prices until packages are set (AI_OPERATIONS_SUITE_ARC.md §5.4).

export const contactHref = '/support/contact/sales'

export const engagements = [
  {
    id: 'training',
    name: 'Training & Enablement',
    icon: GraduationCap,
    gradient: 'from-signal-500 to-synth-600',
    tagline: 'Get your team fluent in Graffiti™ OS, 23Controls™, and the AI Operations Suite.',
    audience: 'Teams adopting Graffiti™ as their local AI system — operators, analysts, and the people who approve what the AI is allowed to do.',
    includes: [
      'How governance works: Identity Anchors, the compliance rulebook, review queues, audit trail',
      'Building and curating Collections for local, cited retrieval (RAG)',
      'Designing, activating, and scheduling workflows on the Conductor Canvas (DAGs)',
      'Using Prompt Shaping and DocFlow to route requests and work through documents',
    ],
    phases: [
      { label: 'Scope', detail: 'We agree on who is being trained and on what, against your actual use case.' },
      { label: 'Sessions', detail: 'Live, hands-on sessions, remote or on site, run by the people who built the platform.' },
      { label: 'Practice', detail: 'Your team works through a real workflow on your own unit, with us on call.' },
    ],
    note: "We don't run a certification program and won't pretend to. Training is delivered directly by our team.",
  },
  {
    id: 'adoption',
    name: 'Adoption Program',
    icon: Rocket,
    gradient: 'from-purple-500 to-synth-600',
    tagline: 'From first unit to first governed workflow, alongside our team.',
    audience: 'Organizations making Graffiti™ and 23Controls™ their core system for secure, local RAG and DAG operations.',
    includes: [
      'Account, Identity Anchor, and unit setup on 23Controls™',
      'Your first document Collections ingested and indexed locally',
      'Your first workflow designed, activated, and scheduled with Conductor',
      'Governance review: which rules apply, who reviews escalations',
    ],
    phases: [
      { label: 'Discover', detail: 'Map one real process worth automating, and the data and rules involved.' },
      { label: 'Deploy', detail: 'Stand up accounts, anchors, and units; ingest the first Collections.' },
      { label: 'Automate', detail: 'Build and schedule the first workflow, with human review where it matters.' },
      { label: 'Hand off', detail: 'Review what ran, what was escalated, and what to automate next.' },
    ],
    note: 'Scoped per organization. Pilot-stage components are named as such during scoping — no surprises after you start.',
  },
  {
    id: 'managed',
    name: 'Managed Services',
    icon: Headset,
    gradient: 'from-ember-500 to-synth-700',
    tagline: 'We help operate your units and workflows so your team can use them.',
    audience: 'Teams that want governed, local AI operations without staffing a platform team for it.',
    includes: [
      'Watching workflow runs and the Scheduler queue, and following up on failures',
      'Keeping compliance rules and policy settings current with your requirements',
      'Unit updates and configuration changes',
      'Support for your human-review queue during busy periods',
    ],
    phases: [
      { label: 'Agree', detail: 'Define what we operate, what stays with you, and how we escalate.' },
      { label: 'Operate', detail: 'We run the agreed scope; your audit trail shows everything we do.' },
      { label: 'Review', detail: 'Regular reviews of runs, escalations, and changes.' },
    ],
    note: 'Offered by arrangement while we are pilot-stage, and capacity is limited. Talk to us about fit before anything else.',
  },
]

